import React from 'react';

export function StepInfoLabel() {
  return <>Oprávnění OZO</>;
}
